import { ImageBackground, Pressable, ScrollView, View, Text ,Image} from 'react-native';
import { ThemedText, ThemedView, themeTextVariants } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { useRef, useState } from 'react';
import NumStepper from '@app/sharedComponents/NumStepper/NumStepper';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import SmilyFace from '../../../../assets/Icons/SmilyFace';
import { FORECLOSURE_STATUS } from '@app/utils';
import ContactUs from '@app/screens/UserProfile/ContactUs';
import { endpoints } from '@app/api/apis';
import { useAppSelector } from '@app/store/hooks';
import axios from 'axios';
import fetchUserDetails from '@app/helper/fetchUserInfo';
import DashedLine from '@app/sharedComponents/DashedLine/DashedLine';
const data1 = [
  {
    id:1,
    subHeading:'We will review your request within 1-2 business days from submission',
    heading:''
  },
  {
    id:2,
    subHeading:'Relationship manager will reach out to verify your closure request',
    heading:''
  },
  {
    id:3,
    subHeading:'Once approved, lien removal & account closure request will be sent to lender',
    heading:''
  }
]

const data2 = [
  {
    id:1,
    subHeading:'Lender will review the request to release collateral within 1-2 business days',
    heading:''
  },
  {
    id:2,
    subHeading:'Once approved, status of collateral will be updated on AMC statement / Demat account within 1-3 business days',
    heading:''
  }
]

const LoanClosureCard = ({foreclosureDetails,isRenewalAllowed = true}:{foreclosureDetails:any,isRenewalAllowed?:boolean}) => {
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };

    const handleCancelAccountClosure = () => {
      setButtonLoader(true)
      const url = endpoints.cancelForeclosure + userDetails?.linkedCredits[0]?.creditId
      axios.post(url,{})
      .then((res)=>{
        console.log('handleCancelAccountClosure',res) 
        closeBottomSheet()
        fetchUserDetails()
      }).catch((err)=>{
        console.log('handleCancelAccountClosure',err)
      }).finally(()=>{
        setButtonLoader(false);
    })
    }
    const foreclosureStatus = foreclosureDetails?.status;
    console.log('foreclosureStatus',foreclosureStatus)
    return(
      <>
      {(foreclosureStatus === FORECLOSURE_STATUS.IN_REVIEW && isRenewalAllowed) ? 
        <ThemedView mx='lg' mt="2xl" p='lg' borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg'>
        <ThemedView flexDirection='row' alignItems='center'>
        <Image
            source={{
                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/hour_glass_blue.png',
            }}
            style={{width: 48, height: 48}}
        />
        <ThemedText variant='b2b' color='text-primary' ml='md' flexShrink={1}>
          Your account closure request has been submitted
        </ThemedText>
        </ThemedView>
        <ThemedView my="lg">
        <DashedLine/>

        </ThemedView>

        <ThemedText variant='b3s' color='text-primary' mb='md' >
        Next steps
        </ThemedText>
        <NumStepper data={data1}/>
        <ThemedView height={24}/>
        <Button label="Cancel request" handlePress={()=>{setIsBottomSheetVisible(true)}} />
    </ThemedView>:
    <ThemedView mx='lg' mt="2xl" p='lg' borderColor='border-primary' backgroundColor='bg-surface-primary' borderWidth={1} borderRadius='lg'>
      <ThemedView flexDirection='row' alignItems='center' borderBottomWidth={1} borderColor='border-primary' borderStyle='dashed' pb='lg' mb='lg'>
      <Image
          source={{
              uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/hour_glass_blue.png',
          }}
          style={{width: 48, height: 48}}
      />
      <ThemedText variant='b2b' color='text-primary' ml='md'>
        Loan closure request submitted to lender
      </ThemedText>
      </ThemedView>
      <ThemedText variant='b3s' color='text-primary' mb='md'>
      Next steps
      </ThemedText>
      <NumStepper data={data2}/>
      <Pressable onPress={()=>{
        setIsBottomSheetVisible(true)
      }}>
        <ThemedText mt='xl' variant='b3s' color='text-action-primary'>
           Need help? Contact us
        </ThemedText>
      </Pressable>
  </ThemedView>}
         <BottomSheetContainer
         isVisible={isBottomSheetVisible}
         close={closeBottomSheet}
         onClose={closeBottomSheet}
         closeOnBackdropPress={true}
         borderTopRightRadius={10}
         borderTopLeftRadius={10}
         containerStyle={{backgroundColor:'#fefefe'}}>
          {(foreclosureStatus === FORECLOSURE_STATUS.IN_REVIEW && isRenewalAllowed) ? (
            <ThemedView p="lg">
              <SmilyFace/>
              <ThemedText variant="h3s" color="text-primary" my="lg">Smart move!</ThemedText>
              <ThemedText variant="b3r" color="text-secondary" mb="lg">By maintaining your credit line, you're ensuring you have a reliable financial safety net to fall back on in times of your need.</ThemedText>
              <Button label="Cancel account closure" buttonLoader={buttonLoader} handlePress={handleCancelAccountClosure}/>
            </ThemedView>
          ) : (
            <ContactUs/>
          )}
         </BottomSheetContainer>
      </>

    )
}

export default LoanClosureCard;